<uc-main-header
	[heading]="headerTitle()"
	[description]="data().headerData.description"
	textColor="text-white"
	descriptionColor="text-white"
	[backgroundStyle]="headerImage()"
>
	<div class="mt-8">
		<uc-course-search-bar
			[options]="degreeLevelOptions"
			[autoSuggestEnabled]="true"
			(enter)="onSearch($event)"
			placeholder="Search Courses"
			[searchLocation]="headerSearchBar"
		/>
	</div>
</uc-main-header>

<main class="container">
	<div class="py-12 border-b sm:py-16">
		<uc-heading
			[headingTitle]="data().pageIntro.title"
			[description]="data().pageIntro.description"
		/>
	</div>
	@if (isLoading()) {
		<uc-top-degree-subjects-skeleton />
	}
	@if (!isLoading() && topDegreeSubjects()) {
		@for (subjects of topDegreeSubjects(); track subjects.title; let last = $last) {
			<uc-degree-subject-category
				class="block divider"
				[ngClass]="{
					'!border-b-0 sm:pb-8': last && data().showViewAllSubjectsLink,
				}"
				[subjects]="subjects"
				[basePath]="link()"
				pageType="hub"
			/>
		}
		@if (data().showViewAllSubjectsLink) {
			<div class="flex justify-center pb-12 border-b sm:pb-16">
				<uc-primary-blue-btn
					class="block w-full sm:max-w-max"
					[link]="viewAllSubjectsLink()"
					buttonText="View All Subjects"
					customStyles="w-full sm:max-w-max"
				/>
			</div>
		}
	}

	@if (shouldFetchDegreeLevelHubLinks()) {
		@if (degreeLevelHubLinks(); as links) {
			<uc-courses-hub-links
				sectionTitle="Search by course type"
				description="Quickly discover available courses by course type. Select your chosen course and browse hundreds of options across subjects."
				[links]="links"
			/>
		}
	}

	@if (data().showClearingAndDirectoryCTA) {
		<div class="divider">
			<div class="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-16">
				<uc-static-card
					[title]="directoryCard.title"
					[desc]="directoryCard.desc"
					[image]="directoryCard.image"
					[link]="directoryCard.link"
					[external]="directoryCard.external"
					customHeight="lg:h-72"
				/>
				<uc-static-card
					[title]="clearingCard().title"
					[desc]="clearingCard().desc"
					[image]="clearingCard().image"
					[link]="clearingCard().link"
					[external]="clearingCard().external"
					customHeight="lg:h-72"
				/>
			</div>
		</div>
	}
</main>
